import React from "react";
// styled components
import { Row, Col, Modal, Button } from "antd";
// models
interface IProps {
  nombre: string;
  modal: boolean;
  eliminar: any;
  cancelar: any;
  indexDocumentacion: number;
}

export const ModalEliminarDocumentosGenerales: React.FC<IProps> = (
  props: IProps
) => {
  return (
    <Modal
      className="modal-eliminar-class ant-modal-close-x2"
      style={{ top: 50 }}
      visible={props.modal}
      onOk={() => props.eliminar(props.indexDocumentacion)}
      onCancel={props.cancelar}
      width={662}
      footer={[
        <Button key="b_cancelar_modal_docu_gen2" className="button-gray-ghost" onClick={props.cancelar}>
          CANCELAR
        </Button>,
        <Button key="b_aceptar_modal_docu_gen2" className="button-azul-radius" onClick={props.eliminar}>
          ACEPTAR
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(162, 103, 95,0.8)",
      }}
    >
      <Row className="width-100">
        <div className="col-12 m-4 d-sm-block d-md-none"></div>
        <Col
          span={24}
          className="font-color-DB2828 font-size-18px justify-content-center mb-2"
        >
          Eliminar documento
        </Col>
        <Col
          span={24}
          className="justify-content-center font-family-Montserrat-Regular font-size-14px"
        >
          Estás a punto de eliminar "{props.nombre}"
        </Col>
        <Col
          span={24}
          className="justify-content-center font-family-Montserrat-Bold font-size-14px mb-2"
        >
          ¿Deseas eliminarlo?
        </Col>
      </Row>
    </Modal>
  );
};
